import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, UNAUTHORIZED } from 'http-status-codes';
import { Subscription } from 'rxjs';

import { httpErrorPages } from './enums/http-error-pages';

@Component({
  selector: 'app-global-error-handling',
  templateUrl: './global-error-handling.component.html',
  styleUrls: ['./global-error-handling.component.scss']
})
export class GlobalErrorHandlingComponent implements OnInit, OnDestroy {

  errorTitle: string;
  errorDescription: string;

  private errorTypeSubscription: Subscription;

  constructor(private readonly activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.errorTypeSubscription = this.activatedRoute
      .data
      .subscribe(data => this.checkErrorType(data.statusCode));
  }

  ngOnDestroy() {
    this.errorTypeSubscription.unsubscribe();
  }

  private checkErrorType(statusCode: number) {
    switch (statusCode) {
      case UNAUTHORIZED:
        this.errorTitle = httpErrorPages.unauthorized.title;
        this.errorDescription = httpErrorPages.unauthorized.description;
        break;
      case FORBIDDEN:
        this.errorTitle = httpErrorPages.forbidden.title;
        this.errorDescription = httpErrorPages.forbidden.description;
        break;
      case NOT_FOUND:
        this.errorTitle = httpErrorPages.notFound.title;
        this.errorDescription = httpErrorPages.notFound.description;
        break;
      case INTERNAL_SERVER_ERROR:
        this.errorTitle = httpErrorPages.internalServerError.title;
        this.errorDescription = httpErrorPages.internalServerError.description;
        break;

      default:
        this.errorTitle = httpErrorPages.otherError.title;
        this.errorDescription = httpErrorPages.otherError.description;
    }
  }

}
